module.exports = __webpack_public_path__ + "images/stickers/thumbsdown.8accff79fb0229cb8940.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/thumbsdown.png
// module id = 811k
// module chunks = 2